import {
    BoxedRow,
    IconChevronLeftRegular,
    NavigationBar,
    Text1,
    Text2,
    TextLink,
    ThemeVariant,
} from '@telefonica/mistica';
import './index.scss';
import { t } from 'i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import StepperBulletTimeLine from '../../../../components/StepperBulletTimeLine';
import { TrackingEvent } from '../../../../models/Orders';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
import BreadCrumbsWrapper from '../../../../components/BreadcrumbsWrapper';

const TimeLineOrders: React.FC = () => {
    const navigate = useNavigate();
    const [params] = useSearchParams();

    let url: string;
    let events: TrackingEvent[] = [];

    let id: string = '0';
    const storage = localStorage.getItem('storage');
    let storageJson: any;
    if (storage) {
        storageJson = JSON.parse(storage);
        events = storageJson.events;
        url = storageJson.url;
        id = storageJson.orderId;
    }

    return (
        <>
            <div className='time-line-orders-page'>
                <div className='time-line-orders-page__header'>
                    {!(isWebviewAndroid || isWebviewIOS) && (
                        <>
                            <div className='time-line-orders-page__header-navigationBar'>
                                <NavigationBar
                                    onBack={() => {
                                        navigate(-1);
                                    }}
                                    title={t('orderDetail')}
                                />
                            </div>
                            <div className='time-line-orders-page__header-return'>
                                <div
                                    className='time-line-orders-page__header-return-cursor'
                                    onClick={() => {
                                        navigate(-1);
                                    }}
                                >
                                    <div className='time-line-orders-page__header-return-cursor-icon'>
                                        <IconChevronLeftRegular size={20} />
                                    </div>
                                    <Text2 medium>{t('returnResponsive')}</Text2>
                                </div>
                            </div>
                        </>
                    )}
                    <div className='time-line-orders-page__header-breadcrumbs'>
                        <ThemeVariant>
                            <BreadCrumbsWrapper
                                title={t('trackingInfoBackTitle')}
                                breadcrumbs={[
                                    { title: t('profileOrders'), url: '/profile/orders' },
                                    { title: t('orderDetail'), url: `/order-detail?id=${params.get('id')}` },
                                ]}
                            />
                        </ThemeVariant>
                    </div>
                </div>

                <div className='time-line-orders-page__content'>
                    <div className='time-line-orders-page__content-title'>
                        <Text1 regular>{t('subtitleTimeLineOrders')}</Text1>
                    </div>

                    <BoxedRow
                        title=''
                        extra={
                            <div className='time-line-orders-page__content-bullets'>
                                {<StepperBulletTimeLine bullets={events} />}
                            </div>
                        }
                    ></BoxedRow>
                    <div className='time-line-orders-page__content-link'>
                        <TextLink
                            underline='on hover'
                            onPress={() => {
                                window.open(`${window.location.protocol}//${url}`, '_blank');
                            }}
                        >
                            {t('locateShipment')}
                        </TextLink>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TimeLineOrders;
